export class CropRect {
    left: number;
    top: number;
    right: number;
    bottom: number;

    static FromUnsortedPositions(startX: number, startY: number, endX: number, endY: number, width: number, height: number): CropRect {
        const result: CropRect = new CropRect();

        result.left = CropRect.truncateDimension(startX, 0, width);
        result.right = CropRect.truncateDimension(endX, 0, width);
        result.top = CropRect.truncateDimension(startY, 0, height);
        result.bottom = CropRect.truncateDimension(endY, 0, height);
        // console.log(`left: ${left} top: ${top} right: ${right} bottom: ${bottom}`);
        let temp: number;
        if (result.left > result.right) {
            temp = result.left;
            result.left = result.right;
            result.right = temp;
        }

        if (result.top > result.bottom) {
            temp = result.top;
            result.top = result.bottom;
            result.bottom = temp;
        }

        return result;
    }

    static truncateDimension(num: number, start: number, end: number): number {
        if (num < start) {
            return start;
        }

        if (num > end) {
            return end;
        }

        return num;
    }

    static scale(rect: CropRect, scaleBy: number): CropRect {
        const result: CropRect = new CropRect();
        result.left = rect.left * scaleBy;
        result.top = rect.top * scaleBy;
        result.bottom = rect.bottom * scaleBy;
        result.right = rect.right * scaleBy;

        return result;
    }

    public width(): number {
        return this.right - this.left;
    }

    public height(): number {
        return this.bottom - this.top;
    }
}